import { FontWeights, makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  itemStyle: {
    overflow: 'auto',
    width: 280,
    height: '100%',
    paddingTop: 10,
  },

  iconStyle: {
    height: 20,
    paddingLeft: 10,
    width: 20,
  },
}));
